


<body>
<!-- 
    <div class="headerPagina">
        <input type="date" [(ngModel)]="filtroData">
        <button (click)="aplicarFiltro()">Filtrar</button>
        <h2 class="tituloPagina">Control Center</h2>
    </div> -->
    <div class="filtroData headerContratos">
        <div class="align-left">
            <label class="labelDate" for="dateStart">Date Start</label>
            <input #dateInput class="inputDate" name="dateStart" type="date" [(ngModel)]="startDateFilter">
            <label class="labelDate" for="dateEnd">Date End</label>
            <input #dateInput2 class="inputDate" name="dateEnd" type="date" [(ngModel)]="endDateFilter">
            <button class="inputDate" (click)="applyFilter()">Filtrar</button>
            <button class="inputDate" (click)="clearFilter()">Limpar filtro</button>
            <!-- <button (click)="calcTimeStay()">calcular</button> -->
        </div>
    <div class="align-left search">
        <input type="text" [(ngModel)]="searchString" (keyup)="aplicarFiltro()" placeholder="Filter">
    </div>
        <div class="averageTime align-right">
            <label for="averageTime" class="labelTime">Average Time Stay</label>
            <textarea name="averageTime" class="textAverage">{{ averageTime | number:'1.2-2' }}</textarea>
            <!-- <input type="number" name="averageTime">{{ averageTime }} -->
        </div>
      
    </div>

    <ul>
        <div>
            <div *ngIf="dataLoaded">
                <table>
                    <thead>
                        <tr>
                            <th>
                                <button (click)="sortBy('License Plate')">License Plate</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('Invoice')">Vehicle Type</button>
                            </th>
                            <th>
                                <button (click)="sortBy('Container')">Supplier</button>
                            </th>
                            <!-- <th>
                                <button (click)="sortBy('Step')">Status</button>
                            </th> -->
                            <th>
                                <button (click)="sortBy('Liner')">Entry</button>
                            </th>
                            <!-- <th>
                                <button (click)="sortBy('Liner')">Entry register by camera</button>
                            </th> -->
                            <th>
                                <button (click)="sortBy('Channel')">Departure</button>
                            </th>
                            <th>
                                <div>
                                    <button (click)="sortBy('Channel')">Time of stay</button>
                                </div>
                                <div>
                                    <input type="number" class="timeStayPar" [(ngModel)]="timeStayMax">
                                </div>
                            </th>
                            <!-- <th>
                                <button (click)="sortByDate('ATA')">Record insertion</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('Dias')">Last Update</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('FreeTime')">Last Update by User</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('TripCost')">Departure weighing</button>
                            </th> -->
                            <th>
                                <button (click)="sortBy2('Handling')">Local entry</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('Demurrage')">Local departure</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('Demurrage')">Local delivery</button>
                            </th>
                            <th>
                                <button (click)="sortBy2('Demurrage')">Entry type</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let item of itemsFiltrados | paginate: { itemsPerPage: count, currentPage: p }">
                            <!-- Seu código HTML para exibir os itens -->
                        <!-- <tr *ngFor="let item of items"> -->
                            <td>{{ item.placaVeiculo }}</td>
                            <td>{{ item.descricaoTipoVeiculo }}</td>
                            <td>{{ item.fornecedor }}</td>
                            <!-- <td>{{ item.status }}</td> -->
                            <td>{{ item.entrada | date : 'dd/MM/yyyy HH:mm'}}</td>
                            <!-- <td>{{ item.entrada | dateFormat }}</td> -->
                            <!-- <td [ngClass]="{ 'verde-value': item.Channel == 'VERDE','negative-value': item.Channel == 'VERMELHO'}">{{
                item.Channel }}</td> -->
                            <td>{{ item.saida | date : 'dd/MM/yyyy HH:mm' }}</td>
                            <!-- <td [ngClass]="{'text-red': item.timeStay > timeStayMax, 'text-green': item.timeStay <= timeStayMax}">{{ item.timeStay >
                                0 ? item.timeStay : 0}}  -->
                            <td class="timeStay">{{ item.timeStay > 0 ? item.timeStay : 0}}
                                <i-feather *ngIf="item.timeStay <= timeStayMax" name="arrow-down-circle" class="arrow-green"></i-feather>
                                <i-feather *ngIf="item.timeStay > timeStayMax" name="arrow-up-circle" class="arrow-red"></i-feather>
                            </td>
                            <!-- <td>{{ item.insercao | dateFormat }}</td> -->
                            <!-- <td>{{ item.atualizacao | dateFormat }}</td> -->
                            <!-- <td>{{ item.usuarioAtualizacao }}</td> -->
                            <!-- <td>{{ item.pesagemSaida | dateFormat }}</td> -->
                            <td>{{ item.entradaLocal | date : 'dd/MM/yyyy HH:mm' }}</td>
                            <td>{{ item.saidaLocal | date : 'dd/MM/yyyy HH:mm' }}</td>
                            <td>{{ item.entregaLocal }}</td>
                            <td>{{ item.tipoEntrada }}</td>
                            <!-- <td
                [ngClass]="{ 'negative-value': item.FreeTime < 0 , 'danger-value': item.FreeTime < 2 && item.FreeTime >= 0 }">
                {{ item.FreeTime }}</td> -->
                            <!-- <td>{{ item.TripCost | currency : 'BRL' }}</td>
                            <td>{{ item.Handling | currency:'BRL':'symbol':'1.2-2' }}</td>
                            <td>{{ item.Demurrage | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td>
                             <button (click)="reutilizar(item, urlConsulta, query)">Reuse</button> 
                            </td>
                            <td>
                                 <button (click)="devolverVazio(item, urlConsulta, query)">Empty Return</button> 
                            </td> -->
                        </tr>
                        
                       


                    </tbody>
                </table>
                <div class="paginator">
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>
        </div>
    </ul>
</body>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>

